
























import Vue, { PropType } from "vue"
import FilterDescription from "~/components/custom/search/FilterDescription.vue"

export interface Option {
  label: string
  value: number
}

export default Vue.extend({
  components: {
    FilterDescription,
  },
  props: {
    value: {
      type: Array as PropType<number[]>,
      required: true,
    },
    isShown: {
      type: Boolean,
      default: false,
    },
    numberOfHits: {
      type: Number,
      default: null,
    },
    options: {
      type: Array as PropType<Option[]>,
      required: true,
    },
  },
  methods: {
    isSelected(prefectureId: number): boolean {
      return this.value.includes(prefectureId)
    },
    handleInput(selectedPrefectureIds: number[]) {
      this.$emit("input", selectedPrefectureIds)
    },
    select(prefectureId: number) {
      this.handleInput(
        this.isSelected(prefectureId)
          ? // 選択を解除
            this.value.filter((id) => id !== prefectureId)
          : // 選択
            [...this.value, prefectureId]
      )
    },
  },
})
